import { Fighter } from './fighter';
import type { FighterStats, FacingDirection } from '@/shared/types';
import { JUMP_FORCE, MAX_HEALTH, PLAYER_SPEED } from '@/shared/constants';

export class TRex extends Fighter {
  readonly name = 'T-REX';
  readonly color = '#2d8c2d';

  readonly stats: FighterStats = {
    maxHealth: MAX_HEALTH,
    speed: PLAYER_SPEED,
    jumpForce: JUMP_FORCE,
    width: 120,
    height: 150,
    attacks: {
      bite: {
        type: 'bite',
        damage: 12,
        range: 90,
        startup: 4,
        active: 6,
        recovery: 8,
        hitBox: { x: 0, y: 30, width: 90, height: 60 },
      },
      'tail-swipe': {
        type: 'tail-swipe',
        damage: 8,
        range: 120,
        startup: 6,
        active: 8,
        recovery: 10,
        hitBox: { x: 0, y: 60, width: 120, height: 45 },
      },
      special: {
        type: 'special',
        damage: 25,
        range: 105,
        startup: 12,
        active: 6,
        recovery: 18,
        hitBox: { x: 0, y: 15, width: 105, height: 90 },
      },
    },
  };

  constructor(x: number, facing: FacingDirection) {
    super(x, facing);
  }
}
